import React from 'react';
import { Helmet } from 'react-helmet';

function PrivacyPolicyPage() {
  return (
    <section className="section page-headroom">
      <Helmet>
        <title>Política de privacidad / Privacy Policy | JC Consultors</title>
        <meta
          name="description"
          content="Política de privacidad general para aplicaciones y sitios web desarrollados por JC Consultors, en español y en inglés."
        />
      </Helmet>

      <div className="site-container">
        <article className="seo-detail-card" data-aos="fade-up">
          <p className="eyebrow">Política general</p>
          <h1>Política de privacidad / Privacy Policy</h1>

          <h2>ESPAÑOL</h2>
          <p>
            Esta política de privacidad se aplica de forma general a los sitios web, aplicaciones y soluciones
            digitales desarrolladas, gestionadas o mantenidas por JC Consultors para sus propios proyectos y para
            proyectos de clientes.
          </p>
          <h3>1. Responsable</h3>
          <p>
            JC Consultors
            <br />
            Email: joan@jctagency.com
            <br />
            Teléfono: 633391411
            <br />
            Dirección: L&apos;Aldea Tarragona 43896
          </p>
          <h3>2. Datos que se pueden tratar</h3>
          <p>
            Dependiendo del servicio, pueden tratarse datos identificativos, de contacto, datos de uso de la
            plataforma y datos técnicos necesarios para la prestación del servicio.
          </p>
          <h3>3. Finalidad del tratamiento</h3>
          <p>
            Gestionar solicitudes de contacto, prestar soporte, mejorar la experiencia de usuario, asegurar el correcto
            funcionamiento de apps y webs, y cumplir obligaciones legales aplicables.
          </p>
          <h3>4. Base jurídica</h3>
          <p>
            El tratamiento se basa en el consentimiento del usuario, la ejecución de una relación contractual y/o el
            cumplimiento de obligaciones legales, según corresponda en cada caso.
          </p>
          <h3>5. Conservación de datos</h3>
          <p>
            Los datos se conservarán durante el tiempo necesario para cumplir la finalidad para la que fueron
            recogidos, y durante los plazos legales exigibles.
          </p>
          <h3>6. Cesiones y encargados</h3>
          <p>
            No se venden datos personales. Pueden intervenir proveedores tecnológicos necesarios (hosting, email,
            analítica o herramientas de gestión), bajo medidas contractuales y de seguridad adecuadas.
          </p>
          <h3>7. Derechos</h3>
          <p>
            El usuario puede solicitar acceso, rectificación, supresión, oposición, limitación y portabilidad de sus
            datos, escribiendo a joan@jctagency.com.
          </p>
          <h3>8. Seguridad</h3>
          <p>
            Se aplican medidas técnicas y organizativas razonables para proteger la información frente a accesos no
            autorizados, alteración o pérdida.
          </p>
          <h3>9. Cambios en esta política</h3>
          <p>
            Esta política puede actualizarse para adaptarse a cambios legales o técnicos. Se recomienda revisarla
            periódicamente.
          </p>

          <h2>ENGLISH</h2>
          <p>
            This privacy policy generally applies to websites, applications, and digital solutions developed, managed,
            or maintained by JC Consultors for both internal projects and client projects.
          </p>
          <h3>1. Data Controller</h3>
          <p>
            JC Consultors
            <br />
            Email: joan@jctagency.com
            <br />
            Phone: 633391411
            <br />
            Address: L&apos;Aldea Tarragona 43896
          </p>
          <h3>2. Data We May Process</h3>
          <p>
            Depending on the service, we may process identification data, contact details, platform usage data, and
            technical data required to provide the service.
          </p>
          <h3>3. Purpose of Processing</h3>
          <p>
            To manage contact requests, provide support, improve user experience, ensure proper operation of apps and
            websites, and comply with applicable legal obligations.
          </p>
          <h3>4. Legal Basis</h3>
          <p>
            Processing is based on user consent, performance of a contractual relationship, and/or compliance with
            legal obligations, depending on the case.
          </p>
          <h3>5. Data Retention</h3>
          <p>
            Data is retained for as long as necessary to fulfill the purpose for which it was collected and for
            applicable legal retention periods.
          </p>
          <h3>6. Data Sharing and Processors</h3>
          <p>
            Personal data is not sold. We may rely on necessary technology providers (hosting, email, analytics, or
            management tools) under appropriate contractual and security safeguards.
          </p>
          <h3>7. Your Rights</h3>
          <p>
            Users may request access, rectification, deletion, objection, restriction, and portability of their data by
            contacting joan@jctagency.com.
          </p>
          <h3>8. Security</h3>
          <p>
            We implement reasonable technical and organizational measures to protect information against unauthorized
            access, alteration, or loss.
          </p>
          <h3>9. Policy Updates</h3>
          <p>
            This policy may be updated to reflect legal or technical changes. Please review it periodically.
          </p>
        </article>
      </div>
    </section>
  );
}

export default PrivacyPolicyPage;
